export const RedirectAdminDashboard = (isSuperAdmin, navigate) => {

    if (isSuperAdmin) {
       return navigate("/superadmindashboard");
    } else {
      return navigate("/admindashboard");
    }

}